import { faCircleUser } from '@fortawesome/free-solid-svg-icons/faCircleUser';
import { MenuItem } from 'react-aria-components';
import { MenuButton } from 'components/menu-button/MenuButton';
import { handleLogout} from '@features/authentication/authFunctions';



export const UserMenu = () => {

	return (
		<MenuButton
			icon={faCircleUser}
			className='user-icon'
			autoFocus={false}
			onAction={(key: string | number | bigint) => {
				if (key === 'logout') {
					handleLogout();
				}
			}}>
			<MenuItem
				className='react-aria-MenuItem without-section'
				key='logout'
				id='logout'
				textValue='logout'>
					Odhlásit
			</MenuItem>
		</MenuButton>
	);
}